/**
 * Generated bundle index. Do not edit.
 */

export {ModalComponent,ModalModule} from './index';
